import React from 'react';
import { Cloud, Database, Layers, Share2, Cpu, Bot } from 'lucide-react';
export const ServicesSection = () => {
  const services = [{
    title: 'Cloud Applications',
    description: 'Custom cloud-based applications designed to scale with your business and provide reliable, secure solutions.',
    icon: <Cloud size={32} className="text-blue-600" data-id="element-199" />
  }, {
    title: 'SharePoint Solutions',
    description: 'Tailored SharePoint implementations that enhance collaboration, document management, and internal workflows.',
    icon: <Share2 size={32} className="text-blue-600" data-id="element-200" />
  }, {
    title: 'Power Platform',
    description: 'Custom solutions using Microsoft Power Platform to automate processes, build apps, and gain insights.',
    icon: <Layers size={32} className="text-blue-600" data-id="element-201" />
  }, {
    title: 'Data Applications',
    description: 'Data-driven applications that help you collect, analyze, and visualize information to make better decisions.',
    icon: <Database size={32} className="text-blue-600" data-id="element-202" />
  }, {
    title: 'AI Development',
    description: 'Cutting-edge AI solutions that bring intelligence to your applications and automate complex tasks.',
    icon: <Cpu size={32} className="text-blue-600" data-id="element-203" />
  }, {
    title: 'Co-pilot Integration',
    description: 'Implementation of AI co-pilots to enhance productivity and provide intelligent assistance to your team.',
    icon: <Bot size={32} className="text-blue-600" data-id="element-204" />
  }];
  return <section id="services" className="py-20 bg-gray-50" data-id="element-205">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-206">
        <div className="text-center mb-16" data-id="element-207">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-208">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-209">
            We provide comprehensive technology solutions to help businesses
            innovate and grow in the digital age.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-210">
          {services.map((service, index) => <div key={index} className="bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow" data-id="element-211">
              <div className="mb-4" data-id="element-212">{service.icon}</div>
              <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-213">
                {service.title}
              </h3>
              <p className="text-gray-600" data-id="element-214">{service.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};